//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VacansiaInfoModal from "~/components/vakansii/VacansiaInfoModal.vue";
import LetterModal from '~/pages/company/questions/letterModal.vue'
import VakansiaCard from "~/components/vakansii/VakansiaCard.vue";
import SPage from '~/components/page/SPage.vue';
import errorParseNetwork from "~/helpers/errorParseNetwork";

export default {
  name: "vakansii",
  head() {
    return {
      title: 'Вакансии',
      meta: [
        {hid: 'metadescription', name: 'description', content: 'Вакансии'},
        {name: 'keywords', content: 'keywords'}
      ],
    };
  },
  data() {
    return {
      isInfoModalOpen: false,
      isVakationModalOpen: false,

      currentOpenCard: {},
      vacansii: [],
    }
  },
  async created() {
    await this.getVakansii();
  },
  computed: {
    breadcrumbs() {
      return [
        {
          path: '/',
          title: 'Главная'
        },
        {
          path: '/vakansii',
          title: 'Вакакнсии'
        },
      ];
    },
    cardList() {
      return [
        {
          title: 'Менеджер',
          shortDescription: 'Требуемый опыт работы: 1–3 года. Полная занятость, полный день, ',
          description: 'Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день, Требуемый опыт работы: 1–3 года. Полная занятость, полный день',
          price: "30000",
        },

        {
          title: 'Менеджер по продажам',
          shortDescription: 'Требуемый опыт работы: 1–3 года. Полная занятость, полный день, ',
          description: 'Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день, Требуемый опыт работы: 1–3 года. Полная занятость, полный день',
          price: "30000",
        },

        {
          title: 'Менеджер по продажам',
          shortDescription: 'Требуемый опыт работы: 1–3 года. Полная занятость, полный день, ',
          description: 'Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день, Требуемый опыт работы: 1–3 года. Полная занятость, полный день',
          price: "30000",
        },
        {
          title: 'Врач по продажам',
          shortDescription: 'Требуемый опыт работы: 1–3 года. Полная занятость, полный день, ',
          description: 'Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день,Требуемый опыт работы: 1–3 года. Полная занятость, полный день, Требуемый опыт работы: 1–3 года. Полная занятость, полный день',
          price: "30000",
        },
      ]
    },
  },

  components: {VakansiaCard, VacansiaInfoModal, LetterModal, SPage},

  methods: {
    async getVakansii() {
      const res = await this.$api.agent.transport.get('vacancy')
        .then(res => {
          return res.data;
        }).catch(err => {
          return {
            error: errorParseNetwork(err.response)
          }
        })

      if (res.error) {
        this.$toast.error(res.error);
        return;
      }

      this.vacansii = res;
    },
    onOpenModal(card) {
      this.currentOpenCard = card;
      this.isInfoModalOpen = true;
      this.$nextTick(() => {
        this.$modal.show("vakansii-info-modal");
      });
    },
    openVakationModal() {
      this.isVakationModalOpen = true;
      this.isInfoModalOpen = false;
      this.$nextTick(() => {
        this.$modal.show("letter-modal");
      });
    }
  },
}
